import { api } from '../services/api'
import { formatPrice } from '../utils/formatPrice'

export class ComissoesOrcamentoService {
  constructor() {
    this.api = api
  }

  async getComissoesOrcamento(nota) {
    if (!nota) {
      throw new Error('Número da nota não informado')
    }

    const response = await this.api.get(`/site/v2/orcamento-crm/listar-info-comissao?numero_nota=${nota}`)

    const info = {
      comissao_vendedor: formatPrice(response.data.comissao_vendedor),
      despesas_extra: formatPrice(response.data.despesas_extra),
      receber: formatPrice(response.data.receber),
      saldo_restante: formatPrice(response.data.saldo_restante),
      total_diferenca: formatPrice(response.data.total_diferenca),
      total_menos_imp: formatPrice(response.data.total_menos_imp),
      total_precobase: formatPrice(response.data.total_precobase),
      total_valor_unitario: formatPrice(response.data.total_valor_unitario),
      saldo_restante_devedor: parseFloat(response.data.saldo_restante) <= 0,
    }

    const dadosGerais = response.data.dados_gerais.map((item) => {
      return {
        ...item,
        quantidade_negociada: new Intl.NumberFormat('pt-BR').format(item.quantidade_negociada),
        preco_base: formatPrice(item.preco_base),
        subtotal_preco: formatPrice(item.subtotal_preco),
        valor_unitario: formatPrice(item.valor_unitario),
        subtotal_vlrunit: formatPrice(item.subtotal_vlrunit),
        diferenca: formatPrice(item.diferenca),
        dif_menosimp: formatPrice(item.dif_menosimp),
        frete_contratado: formatPrice(item.frete_contratado),
        frete_vendido: formatPrice(item.frete_vendido),
        preco_produto: formatPrice(item.preco_produto),
        original_preco_base: item.preco_base,
        original_subtotal_preco: item.subtotal_preco,
        original_valor_unitario: item.valor_unitario,
        original_subtotal_vlrunit: item.subtotal_vlrunit,
        original_diferenca: item.diferenca,
        original_dif_menosimp: item.dif_menosimp,
        original_frete_contratado: item.frete_contratado,
        original_frete_vendido: item.frete_vendido,
        original_preco_produto: item.preco_produto,
      }
    })
    const dadosGastos = response.data.dados_gastos.map((item) => {
      return {
        ...item,
        gasto: item.gasto,
        numero_nota: item.numero_nota,
        numero_pedido: item.numero_pedido,
        valor: formatPrice(item.valor),
        deducao: formatPrice(item.deducao),
        subtotalComissao: formatPrice(item.subtotal_comissao),
        comissao: formatPrice(item.comissao),
        overVendedor: formatPrice(item.over_vendeor),
        receber: formatPrice(item.receber),
        original_valor: item.valor,
        original_deducao: item.deducao,
        original_subtotal_comissao: item.subtotal_comissao,
        original_comissao: item.comissao,
        original_over_vendedor: item.over_vendedor,
        original_receber: item.receber,
      }
    })

    return {
      dadosGerais,
      dadosGastos,
      info: info,
    }
  }

  async updateComissoes(data) {
    if (!data) {
      throw new Error('Dados não informados')
    }

    const response = await this.api.put('/site/v2/orcamento-crm/atualizar-comissao', data)

    return response.data
  }
}
